import React from 'react';
import { Link } from 'react-router-dom';

function SigningFlow() {
  return (
    <div className="docs-content">
      <h1>Signing Flow</h1>
      <p className="docs-lead">
        Understanding the end-to-end flow helps you design workflows and integrate with the API. From creation to completion, every step is auditable.
      </p>

      <h2>1. Create the request</h2>
      <p>
        The sender creates a signing request from the dashboard (<strong>New Request</strong>) or via the API. They upload a PDF (or use a template), add one or more recipients, and place signature and optional text fields. Options include email notifications, expiry date, OTP verification, and optional location or face capture for compliance. The request is stored and a unique document reference is generated.
      </p>

      <h2>2. Recipients receive the link</h2>
      <p>
        Each recipient gets a signing link by email (if notifications are enabled) or the sender can share the link manually. The link opens the sign page in the browser, where the recipient sees the document and the fields they must complete.
      </p>

      <h2>3. Sign or reject</h2>
      <p>
        The recipient can <strong>sign</strong> (draw or type a signature, fill text fields) or <strong>reject</strong> the document. If OTP is enabled, they must enter the code sent to their phone or email before signing. Optional location or face capture can be recorded for the audit trail. The action is saved and the document status is updated.
      </p>

      <h2>4. After signing</h2>
      <p>
        When all required signatures are collected, the document is marked complete. The sender can download the <strong>signed PDF</strong> and the <strong>audit trail</strong> (PDF or via API), which includes timestamps, IP, device info, and any optional verification data. Webhooks fire for events such as request created, document signed, or rejected, so your systems can stay in sync.
      </p>

      <h2>Audit trail</h2>
      <p>
        Every signing action is recorded: who signed, when, from where, and with what device. Use the dashboard’s “Download audit” option or the <Link to="/api-reference/signing">Signing API</Link> to retrieve the audit PDF. This supports legal and compliance requirements for e-signatures.
      </p>

      <p>
        <Link to="/dashboard">← Dashboard Guide</Link> · <Link to="/verification">Document Verification →</Link>
      </p>
    </div>
  );
}

export default SigningFlow;
